import React from 'react';
import { cn } from '@rocco/utils/cn';
import { AlertDialog } from '@rocco/ui/dialog/components/AlertDialog';
import type { Participant } from '../../types';
import { getParticipantName } from '../../utils';

/**
 * The "Remove Participant" button in the chat settings "Members" tab.
 * @see {@link ChatSettingsMembersList}
 */
export function ChatSettingsRemoveButton({
    className,
    participant,
    onConfirm,
    ...props
}: React.ComponentPropsWithoutRef<'button'> & {
    participant: Participant;
    onConfirm: () => void;
}) {
    const participantName = getParticipantName(participant);

    return (
        <AlertDialog
            title="Remove participant"
            description={`Are you sure you want to remove ${participantName} from the conversation?`}
            onConfirm={onConfirm}
            trigger={
                <button
                    className={cn(
                        'rounded-[8px] border border-black/70 px-[8px] py-[4px] font-medium text-black/70 hover:bg-black/10 disabled:pointer-events-none disabled:opacity-50',
                        className,
                    )}
                    aria-label="Remove participant"
                    {...props}
                >
                    Remove
                </button>
            }
        />
    );
}
